import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ROLES } from "../../config/roles";
import { initiateAgentPlayerChat } from "../../services/api";
import toast from "react-hot-toast";

const OpenToRepresentationBanner = ({ player }) => {
  const { currentRole } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  // Only show for agents
  if (currentRole !== ROLES.Agent && currentRole !== ROLES.AgencyAdmin) {
    return null;
  }

  // Only show if player has claim_representation enabled
  if (!player?.platform_data?.claim_representation) {
    return null;
  }

  // Handle send proposal - redirect to invite player page
  const handleSendProposal = () => {
    navigate('/agent/invite-player', {
      state: { 
        selectedPlayer: player,
        email: player?.email || "",
        fromRepresentationBanner: true
      }
    });
  };

  // Handle chat with player
  const handleChatWithPlayer = async () => {
    try {
      // console.log("player", player);
      // return;

      if(!player?.platform_data?.account_id){
        toast.error("Player account ID not found");
        return;
      }
      const result = await initiateAgentPlayerChat(player?.platform_data?.account_id, true);
      if (result.success) {
        toast.success("Chat initiated successfully!");
        // Navigate to inbox with the channel information
        navigate('/inbox', {
          state: {
            channelId: result.data.channel_id,
            channelType: result.data.channel_type
          }
        });
      } else {
        toast.error(result.error || "Failed to initiate chat");
      }
    } catch (error) {
      console.error("Error initiating chat:", error);
      toast.error("Failed to initiate chat. Please try again.");
    }
  };

  return (
    <>
      <div
        className="w-full flex justify-between items-center px-6 py-3 border border-[#9DC0EE] bg-[#F5F9FF] rounded-xl shadow-lg"
        style={{ boxShadow: "0px 4px 16px 0px #100B2714" }}
      >
        <div className="flex gap-2">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="24"
              height="24"
              rx="6"
              fill="url(#paint0_linear_2709_20767)"
            />
            <path
              d="M12 9V14"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <circle cx="12" cy="17" r="1" fill="white" />
            <defs>
              <linearGradient
                id="paint0_linear_2709_20767"
                x1="12"
                y1="-4.5"
                x2="12"
                y2="28"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#4DCAFF" />
                <stop offset="1" stopColor="#4EA3E0" />
              </linearGradient>
            </defs>
          </svg>

          <div className="flex flex-col">
            <span className="text-base font-medium text-[#1A212F]">
              {player.name} is Open to Representation
            </span>
            <span className="text-xs text-[#2F3F53]">
              {player.name} is currently considering agent representation.
              Submit your proposal if you believe your agency is the right fit.
            </span>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={handleChatWithPlayer}
            className="border border-[#3D8AF1] text-[#3D8AF1] px-4 py-2 rounded-lg font-medium hover:bg-blue-50 transition-colors flex items-center gap-2"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.6003 7.58366C12.6003 10.7557 10.0057 13.3503 6.83366 13.3503C5.83783 13.3503 4.90616 13.1057 4.09116 12.6678L1.16699 13.417L1.91616 10.4928C1.47824 9.67783 1.23366 8.74616 1.23366 7.75033C1.23366 4.57824 3.82824 1.98366 7.00033 1.98366C10.1724 1.98366 12.767 4.57824 12.767 7.75033"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Chat with Player
          </button>
          <button
            onClick={handleSendProposal}
            className="bg-[#3D8AF1] flex items-center gap-2 text-white px-4 py-2 rounded-lg font-medium hover:bg-blue-600 transition-colors"
          >
            Send proposal{" "}
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.33398 6.00016H10.6673M10.6673 6.00016L6.00065 1.3335M10.6673 6.00016L6.00065 10.6668"
                stroke="white"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </>
  );
};

export default OpenToRepresentationBanner;
